import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import Swal from "sweetalert2";
import Header from "components/Headers/Header";
import Cookies from "universal-cookie";

const ReporteTaller = () => {
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [loading, setLoading] = useState(false);

  const cookie = new Cookies();
  const tallerNombre = cookie.get("nombre");

  const descargarExcel = async () => {
    if (!fechaInicio || !fechaFin) {
      Swal.fire(
        "Campos requeridos",
        "Debes seleccionar ambas fechas.",
        "warning",
      );
      return;
    }

    const payload = {
      inspector: "",
      nombretaller: tallerNombre,
      regional: "",
    };

    const url = `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerGnv/${fechaInicio}/${fechaFin}`;

    setLoading(true);
    try {
      const response = await axios.post(url, payload, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `ReporteGNV_${fechaInicio}_a_${fechaFin}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Ocurrió un error al descargar el reporte.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Card className="shadow mb-4">
          <CardBody>
            <h4 className="mb-4">Reportes facturación GNV</h4>
            <Form>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label>Fecha Inicio:</Label>
                    <Input
                      type="date"
                      value={fechaInicio}
                      onChange={(e) => setFechaInicio(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Fecha Fin:</Label>
                    <Input
                      type="date"
                      value={fechaFin}
                      onChange={(e) => setFechaFin(e.target.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <div className="text-right">
                <Button
                  color="success"
                  onClick={descargarExcel}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner size="sm" className="mr-2" /> Descargando...
                    </>
                  ) : (
                    "Descargar Excel"
                  )}
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default ReporteTaller;
